<script setup>
import { ref } from 'vue';
import InputLabel from './InputLabel.vue';
import TextInput from './TextInput.vue';
import InputError from './InputError.vue';
import { EyeIcon, EyeSlashIcon } from "@heroicons/vue/24/solid";

const props = defineProps({
    modelValue: {
        type: String,
        default: ''
    },
    errorMessage: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    },
    labelClass: {
        type: String,
        default: ''
    },
    autoComplete: {
        type: String,
        default: 'current-password'
    }
});

const emit = defineEmits(['update:modelValue']);

const isPasswordVisible = ref(false);

const togglePasswordVisibility = () => {
    isPasswordVisible.value = !isPasswordVisible.value;
};
</script>

<template>
    <div class="relative">
        <InputLabel
            for="password"
            :value="label"
            :class="labelClass"
            required="true"
        />
        <div class="relative mt-1">
            <TextInput
                id="password"
                :value="modelValue"
                @input="(event) => emit('update:modelValue', event.target.value)"
                :type="isPasswordVisible ? 'text' : 'password'"
                class="block w-full pr-10"
                required
                :autocomplete="autoComplete"
            />

            <button
                type="button"
                @click="togglePasswordVisibility"
                class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500"
                aria-label="Toggle password visibility"
            >
                <span v-if="isPasswordVisible"><EyeIcon aria-hidden="true" class="h-6 w-6" /></span>
                <span v-else><EyeSlashIcon aria-hidden="true" class="h-6 w-6" /></span>
            </button>
        </div>

        <InputError
            class="mt-2"
            :message="errorMessage"
        />
    </div>
</template>
